import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import useCompareConceptsOptions from './useCompareConceptsOptions';
import MultiselectDropdownNew from '../../../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import GlobalPercentageSwitch from '../../../../global-percentage-switch/GlobalPercentageSwitch';
import SelectedOptionsList from '../../../../selected-options-list/SelectedOptionsList';

import scss from './CompareFilter.module.scss';

function CompareFilter({
  selectedConcept,
  selectedCompareConcepts,
  onSelectCompareConcept,
  isGlobalPercentage,
  onChangeGlobalPercentage,
  isGlobalPercentageEnabled,
  isLoading,
}) {
  const { t } = useTranslation('resonance');

  const compareConceptsOptions = useCompareConceptsOptions(selectedConcept);

  const handleRemoveCompareConcept = (conceptValue) => {
    const newCompareConcepts = selectedCompareConcepts.filter(({ value }) => value !== conceptValue);
    onSelectCompareConcept(newCompareConcepts);
  };

  useEffect(() => {
    if (selectedConcept?.value && selectedCompareConcepts.length) {
      onSelectCompareConcept([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConcept?.value]);

  return (
    <div className={scss.wrapper}>
      <WithLabel
        label={`${t('compareTo')}:`}
        variant={LABEL_STYLES.CUSTOM}
        isBold
        extraClassName={scss.messagesWrapper}>
        <MultiselectDropdownNew
          value={selectedCompareConcepts}
          options={compareConceptsOptions}
          onChange={onSelectCompareConcept}
          placeholder={t('selectConcept')}
          disableNewOptions
          disableSelectedOptionsRender
          isLoading={isLoading}
        />

        <SelectedOptionsList selectedOptions={selectedCompareConcepts} onRemoveOption={handleRemoveCompareConcept} />
      </WithLabel>

      {isGlobalPercentageEnabled ? (
        <GlobalPercentageSwitch
          isGlobalPercentage={isGlobalPercentage}
          onChangeGlobalPercentage={onChangeGlobalPercentage}
        />
      ) : null}
    </div>
  );
}

export default CompareFilter;
